import { render } from "./create.vue?vue&type=template&id=5a01ee1a"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/pages/entries/create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a01ee1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a01ee1a', __exports__)) {
    api.reload('5a01ee1a', __exports__)
  }
  
  module.hot.accept("./create.vue?vue&type=template&id=5a01ee1a", () => {
    api.rerender('5a01ee1a', render)
  })

}


export default __exports__